const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M17.344 2.688l-1.632 4.864-1.696-4.864q-0.224-0.704 0.096-1.344t0.992-0.896q0.96-0.32 1.792 0.352t0.448 1.888zM2.336 14.304l4.896 1.696-4.896 1.664q-0.672 0.256-1.344-0.096t-0.896-1.024q-0.32-0.96 0.384-1.792t1.856-0.448zM14.016 29.312l1.696-4.864 1.632 4.864q0.224 0.672-0.096 1.344t-0.992 0.896q-0.96 0.32-1.792-0.384t-0.448-1.856zM29.024 17.664l-4.896-1.664 4.896-1.696q0.672-0.224 1.344 0.096t0.896 1.024q0.32 0.96-0.384 1.824t-1.856 0.416zM7.424 5.408l2.272 4.64-4.64-2.304q-0.672-0.32-0.896-0.992t0.096-1.344q0.512-1.024 1.6-0.96t1.568 0.96zM5.056 24.224l4.64-2.272-2.272 4.64q-0.32 0.672-0.992 0.896t-1.376-0.096q-0.992-0.512-0.96-1.6t0.96-1.568zM23.936 26.592l-2.272-4.64 4.64 2.272q0.672 0.32 0.896 1.024t-0.096 1.344q-0.512 0.992-1.6 0.96t-1.568-0.96zM26.304 7.744l-4.64 2.304 2.272-4.64q0.32-0.704 0.992-0.928t1.376 0.128q0.992 0.512 0.96 1.6t-0.96 1.536zM15.712 23.52q-3.104 0-5.312-2.24t-2.208-5.28 2.208-5.312 5.312-2.208 5.28 2.208 2.176 5.312-2.176 5.28-5.28 2.24zM15.712 11.84q-1.728 0-2.976 1.216t-1.248 2.944 1.248 2.944 2.976 1.216 2.944-1.216 1.216-2.944-1.216-2.944-2.944-1.216z"
});

const SvgSun = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-sun",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun.d252f171.svg";
export { ForwardRef as ReactComponent };